import moment from 'moment'
import Constants from '@/utils/Constants'
import Errors from '@/utils/Errors'
import { v4 as uuidv4 } from 'uuid'

export default {

  // *********************
  // Date
  // *********************
  /**
   * 日付を指定のフォーマットで返す
   * @param  format  YYYY/MM/DD HH:mm:ss
   */
  dateFormat (value, format) {
    if (!value) return Constants.BlankValue
    let v = new Date(value)
    return moment(v).format(format)
  },

  /**
   * GMTをJSTに変換して指定のフォーマットで返す
   * @param  format  YYYY/MM/DD HH:mm:ss
   */
  jstDateFormat (value, format) {
    let v = new Date(value)
    return moment(v).add(9, 'hours').format(format)
    // return moment(value).tz('Asia/Tokyo').format(format)
    // return moment(value).add(9, 'h').format(format)
  },

  /**
   * DateをISO8601形式で返す
   */
  getISO8601Date (value) {
    return moment(value)
      .subtract('hours', 9)
      .utc()
      .utcOffset("+09:00")
      .format()
  },

  /*
    数値のカンマ区切り・小数点指定・0埋め・分割を行う
    n: Number
    decimal: 小数点桁数(0埋めもされる)
    commaFlag: カンマ区切りを行うかどうか
  */
  numberFormat (n, decimal, commaFlag) {
    if (n === undefined || n === null || n === '') {
      return ''
    }
    n = Math.floor(n * Math.pow(10, decimal)) / Math.pow(10, decimal)
    n = n.toFixed(decimal)
    n = commaFlag ? n.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : n
    return n
  },

  // *********************
  // Array
  // *********************
  removeArray (array, value) {
    array.some((item, index) => {
      if (item === value) {
        array.splice(index, 1)
      }
    })
    return array
  },

  // *********************
  // Object
  // *********************
  /**
   * keyでソート
   */
  sortByKey (key, ascending) {
    return (a, b) => {
      if (a[key] < b[key]) return ascending ? -1 : 1
      if (a[key] > b[key]) return ascending ? 1 : -1
      return 0
    }
  },

  // *********************
  // HTML
  // *********************
  /**
   * HTMLデコード
   */
  decodeHTML (str) {
    str = str.replace(/&lt;/g, '<')
    str = str.replace(/&gt;/g, '>')
    str = str.replace(/&amp;/g, '&')
    str = str.replace(/&apos;/g, '\'')
    str = str.replace(/&#039;/g, '\'')
    str = str.replace(/&quot;/g, '"')
    return str
  },
  /**
   * 改行コードを変換
   */
  decodeBraak (str) {
    if (!str) return ''
    return str.replace(/\n/g, '<br>')
  },

  // *********************
  // Constants
  // *********************
  /**
   * 定数のvalueからラベルを取得
   * @param [array]  keys  
   * @param [string] value 
   */
  getConstantsLabel: (keys, value) => {
    let target = 
      keys.length === 2 ? Constants[keys[0]][keys[1]] :
      keys.length === 3 ? Constants[keys[0]][keys[1]][keys[2]] :
        Constants[keys[0]]

    try {
      return target
        .filter(item => item.value === value)[0].label

    /* eslint-disable no-new */
    } catch (e) {
      return ''
    }
  },

  // *********************
  // Model
  // *********************
  /**
   * オブジェクト配列から任意のキーでフィルタリングして目的の値を取得する
   * @param [array]  obj         検索元のオブジェクト配列
   * @param [string] fromKey     オブジェクト配列からレコードを取得するための検索キー
   * @param [string] fromValue   オブジェクト配列からレコードを取得するための検索値
   * @param [string] toKey       取得したいオブジェクト配列キー
   */
  getObjectArrayValue: (obj, fromKey, fromValue, toKey) => {
    try {
      return obj.filter(item => item[fromKey] === fromValue)[0][toKey]
    // eslint-disable-next-line
    } catch (e) {
      return ''
    }
  },

  // *********************
  // Bit
  // *********************
  /**
   * 整数からビット値に変換
   */
  bitArrayByInt (n) {
    let array = ('000000' + n.toString(2)).slice(-7).split('')
    return array.reverse()
  },
  /**
   * ビット値から整数に変換
   */
  intByBitArray (array) {
    let n = 0
    if (typeof array !== 'object' || array.length !== 7) return n
    if (array[0] === '1') n += 1
    if (array[1] === '1') n += 2
    if (array[2] === '1') n += 4
    if (array[3] === '1') n += 8
    if (array[4] === '1') n += 16
    if (array[5] === '1') n += 32
    if (array[6] === '1') n += 64
    return n
  },

  // *********************
  // Csv
  // *********************
  downloadDataAsCsv (content, fileName) {
    var UTF_8_BOM = '%EF%BB%BF'
    var data = 'data:text/csv;charset=utf-8,'
             + UTF_8_BOM
             + encodeURIComponent(content)
    var element = document.createElement('a')
    element.href = data
    element.setAttribute('download', fileName)
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  },

  // *********************
  // Error
  // *********************
  /**
   * APIのレスポンスを解析して結果を返す
   * @return [int]     result  レスポンス状態
   *                             0: エラーがひとつ以上ある
   *                             1: 全て正常処理
   * @return [int]     error   エラー状態
   *                             0: アプリケーションエラー
   *                             1: APIエラー
   */
  parseResponse: (res) => {
    // console.log('Utility.parseResponse(res)', res)

    // APIリクエストの正常処理数
    let success = res.filter(item => item.status === Errors.Status.Success).length

    /**
     * エラー状態を取得
     */
    var getErrorStatus = () => {
      // APIレスポンスにあるエラーコードを配列に格納
      let codeList = []
      res.filter(item => item.status === Errors.Status.Failure)
        .forEach(item => {
          if (item.data.errors) {
            item.data.errors.forEach(err => codeList.push(err.code))
          }
        })
      // console.log('codeList', codeList)

      // エラー情報がない場合
      if (!codeList.length) return 0

      // アプリケーションエラーを判別
      let appErrorCount = Errors.AppErrorCode.filter(code => codeList.indexOf(code) !== -1).length
      // console.log('appErrorCount', appErrorCount)

      return appErrorCount === 0 ? 1 : 0
    }

    // レスポンスデータの作成
    let response = {
      result: res.length - success === 0 ? 1 : 0,
      error: getErrorStatus()
    }

    return response
  },

  generateUuid: () => {
    return uuidv4()
    // // https://github.com/GoogleChrome/chrome-platform-analytics/blob/master/src/internal/identifier.js
    // // const FORMAT: string = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
    // // let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
    // let chars = "xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx".split("");
    // for (let i = 0, len = chars.length; i < len; i++) {
    //     switch (chars[i]) {
    //         case "x":
    //             chars[i] = Math.floor(Math.random() * 16).toString(16);
    //             break;
    //         case "y":
    //             chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
    //             break;
    //     }
    // }
    // return chars.join("");
  },
  
  sanitizeUrl: (url) => {
    if (typeof url !== 'string') return '#'
    return /^(https?|hbmov):\/\//i.test(url) ? url : '#'
  }
}
